const questions = [
  {
    title: 'Wie viele Personen leben in Ihrem Haushalt?',
    name: 'person',
    id: 1,
    options: [
      {
        text: '1 Person',
        param: 1,
      },
      {
        text: '2 Personen',
        param: 2,
      },
      {
        text: '3 Personen',
        param: 3,
      },
      {
        text: 'Mehr als 3 Personen',
        param: 4,
      },
    ],
    tipps: [
      {
        title: 'Duschen statt baden.',
        content:
          'Ein Vollbad benötigt durchschnittlich dreimal so viel Energie und Wasser wie fünf Minuten duschen.',
        icon: 'hand-holding-water',
      },
      {
        title: 'Warmwasser achtsam verwenden.',
        content:
          'Jeder Tropfen Wasser, der nicht erhitzt werden muss, hilft. Ein Sparduschkopf kann zwischen 10-15 Liter pro Person und Tag einsparen.',
        icon: 'tint',
      },
    ],
  },
  {
    title: 'Wie viele Wochen, über das Jahr verteilt, ist niemand zu Hause?',
    name: 'week',
    id: 2,
    options: [
      {
        text: 'Weniger als 2 Wochen',
        param: 1,
      },
      {
        text: '4 Wochen',
        param: 2,
      },
      {
        text: '6 Wochen',
        param: 3,
      },
      {
        text: 'Mehr als 6 Wochen',
        param: 4,
      },
    ],
    tipps: [
      {
        title: 'Türdichtung testen.',
        content:
          'Kontrollieren Sie regelmäßig, ob die Tür Ihres Kühl- oder Gefriergerätes gut und dicht schließt.',
        icon: 'temperature-frigid',
      },
      {
        title: 'Heizung runterdrehen.',
        content: 'Schon 1°C weniger spart bis zu 6% Heizkosten.',
        icon: 'thermometer-three-quarters',
      },
    ],
  },
  {
    title: 'Kühlen Sie im Sommer Ihr Zuhause mit Klimaanlage?',
    name: 'airConditioner',
    id: 3,
    options: [
      {
        text: 'Ja',
        param: 1,
      },
      {
        text: 'Nein',
        param: 0,
      },
    ],
    tipps: [
      {
        title: 'Nachts lüften.',
        content:
          'Halten Sie in den Sommermonaten untertags die Fenster geschlossen, so bleibt die Hitze draußen. Lüften Sie dafür nachts.',
        icon: 'clock',
      },
      {
        title: 'Richtig beschatten.',
        content:
          'Jalousien und Rollläden an der Gebäudeaußenseite halten Ihr Zuhause kühl.',
        icon: 'clouds-sun',
      },
    ],
  },
  {
    title:
      'Über welchen Ausstattungslevel bei Haushaltsgeräten verfügt Ihr Haushalt?',
    name: 'kitchenAnswer',
    id: 4,
    options: [
      {
        text: 'Ohne Waschmaschine + Geschirrspüler',
        param: 1,
      },
      {
        text: 'Waschmaschine + Geschirrspüler + Gefrierfach',
        param: 2,
      },
      {
        text: 'Waschmaschine + Geschirrspüler + Kühlkombi',
        param: 3,
      },
      {
        text: 'Waschmaschine + Geschirrspüler + Kühlkombi + Trockner',
        param: 4,
      },
    ],
    tipps: [
      {
        title: 'Eco-Programm bei Geschirrspüler und Waschmaschine.',
        content:
          'Dabei wird das Wasser weniger erhitzt und verbraucht somit weniger Energie.',
        icon: 'flower-daffodil',
      },
      {
        title: 'Niedrige Temperatur bei der Waschmaschine wählen.',
        content:
          'Das kann bis zu 50% der Energie im Vergleich zu höheren Temparaturen sparen.',
        icon: 'thermometer-quarter',
      },
    ],
  },
  {
    title: 'Wie alt sind Ihre Haushaltsgeräte im Durchschnitt?',
    name: 'age',
    id: 5,
    options: [
      {
        text: 'Neu',
        param: 1,
      },
      {
        text: 'Bis 10 Jahre',
        param: 2,
      },
      {
        text: 'Über 10 Jahre',
        param: 3,
      },
    ],
    tipps: [
      {
        title: 'Neue Geräte am besten mit A+++',
        content:
          'Achten Sie beim Kauf neuer Geräte auf die Energieeffizienzklasse: A+++ verbraucht etwa 60% weniger als A.',
        icon: 'flower-daffodil',
      },
      {
        title: 'Kühlschrank weg von Wärmequellen.',
        content:
          'Kühlschränke am besten nicht neben den Herd oder Heizkörper stellen. Warme Speisen erst auskühlen lassen und dann ins Kühl- oder Gefriergerät.',
        icon: 'snowflakes',
      },
    ],
  },
  {
    title: 'Welche Lampen verwenden Sie vorwiegend Zuhause?',
    name: 'lightAnswer',
    id: 6,
    options: [
      {
        text: 'Mischbeleuchtung',
        param: 1,
      },
      {
        text: 'Glühbirne ',
        param: 2,
      },
      {
        text: 'Energiesparlampen',
        param: 3,
      },
      {
        text: 'LEDs',
        param: 4,
      },
    ],
    tipps: [
      {
        title: 'Energiesparende Lampen verwenden.',
        content:
          'LED-Lampen verbrauchen in der Regel weniger als ein Fünftel der Energie konventioneller Glühlampen. Die Lebensdauer ist bis zu 30-mal so hoch und die Erwärmung ist weit geringer als bei Glühlampen.',
        icon: 'lightbulb',
      },
      {
        title: 'Direkt beleuchten.',
        content:
          'Vermeiden Sie indirekte Beleuchtung. Das spart Strom und senkt die Wärmebelastung.',
        icon: 'lightbulb-on',
      },
    ],
  },
  {
    title:
      'Welche dieser Geräte haben Sie zuhause für Home Office und Home Entertainment?',
    name: 'homeOfficeAnswer',
    id: 7,
    options: [
      {
        text: 'TV-Gerät',
        param: 'mindestausstattung',
      },
      {
        text: 'TV + PC mit WLAN',
        param: 'standardausstattung',
      },
      {
        text: 'TV + PC mit WLAN + Spielekonsole',
        param: 'komfortausstattung',
      },
      {
        text: 'Mehrere TVs+ PC mit WLAN + Spielekonsole',
        param: 'vollausstattung',
      },
    ],
    tipps: [
      {
        title: 'TV-Geräte sorgfältig auswählen.',
        content:
          'Der Stromverbrauch eines Fernsehers hängt vor allem von der Bildschirmgröße ab. Achten Sie beim Kauf auf das EU-Energielabel.',
        icon: 'tv',
      },
      {
        title: 'Betriebszeit der PCs verringern.',
        content:
          'Vermeiden Sie unnötige Betriebszeiten Ihres Computers. Aktivieren und optimieren Sie den Bildschirmschoner. Das spart Strom und reduziert die Wärmebelastung Ihres Heims.',
        icon: 'laptop',
      },
    ],
  },
  {
    title:
      'Schalten Sie Ihre Geräte immer aus anstatt sie im Standby-Modus zu lassen?',
    name: 'standbyAnswer',
    id: 8,
    options: [
      {
        text: 'immer',
        param: 1,
      },
      {
        text: 'meistens',
        param: 2,
      },
      {
        text: 'selten',
        param: 3,
      },
      {
        text: 'nie',
        param: 4,
      },
    ],
    tipps: [
      {
        title: 'Ausstecken statt Standby.',
        content:
          'Trennen Sie unbenutzte Geräte ganz vom Netz, denn auch im Standby-Modus verbrauchen Sie Strom.',
        icon: 'plug',
      },
      {
        title: 'Stromfresser aufspüren.',
        content:
          'Mit einem Stromverbrauchsmessgerät kommen Sie den Stromfressern in Ihrem Zuhause am besten auf die Spur. Der Verleih ist für Wien Energie-Kund*innen gratis.',
        icon: 'search',
      },
    ],
  },
];
const averageValues = [
  {
    name: 'Beleuchtung',
    // 1 Person, 2 Personen, 3 Personen, 4 Personen
    average: [130, 270, 325, 390],
  },
  {
    name: 'Klimageräte',
    // 1 Person, 2 Personen, 3 Personen, 4 Personen
    average: [518, 518, 518, 518],
  },
  {
    name: 'Küche und Haushalt',
    // 1 Person, 2 Personen, 3 Personen, 4 Personen
    average: [894, 1584, 2034, 2479],
  },
  {
    name: 'Office und Entertainment',
    // 1 Person, 2 Personen, 3 Personen, 4 Personen
    average: [230, 370, 615, 710],
  },
];
// *********** Raumkühlgeräte ***********
const getAirConditionerResult = input => (input === 1 ? 517.5 : 0);

// *********** BELEUCHTUNG ***********
const lightResult = [
  {
    light: 1,
    value: 246.4,
  },
  {
    light: 2,
    value: 327.6,
  },
  {
    light: 3,
    value: 156,
  },
  {
    light: 4,
    value: 117,
  },
];
const getLightResult = (lightAnswer, person) =>
  lightResult.find(res => res.light === lightAnswer).value *
  (1 + (person > 1 ? person * 10 : 0) / 100);

// *********** Küche & Haushalt ***********
const kitchenResult = [
  {
    kitchen: 1,
    // 1 Person, 2 Personen, 3 Personen, 4 Personen
    value: [589.7, 830.7, 1052, 1273.3],
  },
  {
    kitchen: 2,
    value: [786.7, 1089.5, 1360, 1630.5],
  },
  {
    kitchen: 3,
    value: [791.7, 1363.6, 1903.3, 2443],
  },
  {
    kitchen: 4,
    value: [1110.7, 1545.2, 1947.5, 2349.8],
  },
];
const getKitchenResult = (kitchenAnswer, person, week, age) => {
  const weekPercentage = [1, 0.97, 0.94, 0.91];
  const deviceAgePercentage = [1, 1.3, 1.59];
  const kitchenValue = kitchenResult.find(res => res.kitchen === kitchenAnswer)
    .value[person - 1];
  const final =
    kitchenValue * weekPercentage[week - 1] * deviceAgePercentage[age - 1];
  return final;
};

// *********** Home Office ***********
const homeOfficeData = [
  {
    param: 'mindestausstattung',
    // Standby always, often, sometimes, never
    standbyValue: [9.1, 36.6, 128, 182.9],
    consumeValue: 211.2,
  },
  {
    param: 'standardausstattung',
    standbyValue: [13.7, 54.9, 192.1, 274.4],
    consumeValue: 253.2,
  },
  {
    param: 'komfortausstattung',
    standbyValue: [28.5, 121.8, 426.2, 608.8],
    consumeValue: 409.8,
  },
  {
    param: 'vollausstattung',
    standbyValue: [50.2, 200.8, 702.9, 1064.5],
    consumeValue: 864.4,
  },
];
const getHomeOfficeResult = (homeOfficeAnswer, standbyAnswer) => {
  const homeOfficeValues = homeOfficeData.find(
    res => res.param === homeOfficeAnswer,
  );
  const result =
    homeOfficeValues.consumeValue +
    homeOfficeValues.standbyValue[standbyAnswer - 1];
  return result;
};
const getPercentage = (param, total) => Math.round((param / total) * 100);

// *********** FINAL RESULT ***********
const getResults = answers => {
  const person = answers.find(answ => answ.label === 'person').param;
  const week = answers.find(answ => answ.label === 'week').param;
  const age = answers.find(answ => answ.label === 'age').param;
  const lightAnswer = answers.find(answ => answ.label === 'lightAnswer').param;

  const { param: airConditioner } = answers.find(
    answ => answ.label === 'airConditioner',
  );
  const kitchenAnswer = answers.find(
    answ => answ.label === 'kitchenAnswer',
  ).param;

  const homeOfficeAnswer = answers.find(
    answ => answ.label === 'homeOfficeAnswer',
  ).param;
  const standbyAnswer = answers.find(
    answ => answ.label === 'standbyAnswer',
  ).param;

  const lightsValue = Math.round(getLightResult(lightAnswer, person));
  const airConditionerValue = Math.round(
    getAirConditionerResult(airConditioner),
  );
  const kitchenValue = Math.round(
    getKitchenResult(kitchenAnswer, person, week, age),
  );
  const homeOfficeValue = Math.round(
    getHomeOfficeResult(homeOfficeAnswer, standbyAnswer),
  );

  // Get All Average Values according to Person
  const getAveragePercentage = (name, value) => {
    const average = averageValues.filter(aver => aver.name === name)[0].average[
      person - 1
    ];
    const sub = value - average;
    const percentage = Math.round((sub / average) * 100);
    return { percentage, value: average };
  };

  const total =
    lightsValue + airConditionerValue + kitchenValue + homeOfficeValue;
  const results = [
    {
      name: 'Klimageräte',
      color: '#EB6626',
      value: getPercentage(airConditionerValue, total),
      kwh: Math.round(airConditionerValue / 10) * 10,
      tipps: [
        {
          icon: 'snowflakes',
          title: '2 Tage',
          content: 'eine neue Kühl-Gefrierkombi betreiben',
        },
        {
          icon: 'snowflake',
          title: '0,7 Tage',
          content:
            'eine Kühl-Gefrierkombi betreiben, die über 15 Jahre alt ist',
        },
      ],
      average: getAveragePercentage('Klimageräte', airConditionerValue),
    },
    {
      name: 'Küche und Haushalt',
      color: '#005797',
      value: getPercentage(kitchenValue, total),
      kwh: Math.round(kitchenValue / 10) * 10,
      tipps: [
        {
          icon: 'stocking',
          title: '1,4 Stunden',
          content: 'bügeln',
        },
        {
          icon: 'hat-chef',
          title: '1 Mahlzeit',
          content: 'kochen',
        },
      ],
      average: getAveragePercentage('Küche und Haushalt', kitchenValue),
    },
    {
      name: 'Beleuchtung',
      color: '#D9A300',
      value: getPercentage(lightsValue, total),
      kwh: Math.round(lightsValue / 10) * 10,
      tipps: [
        {
          icon: 'lightbulb',
          title: '167 Stunden',
          content: 'eine 6 Watt LED-Lampe leuchten lassen',
        },
        {
          icon: 'lightbulb-on',
          title: '17 Stunden',
          content: 'eine 60 Watt Glühbirne leuchten lassen',
        },
      ],
      average: getAveragePercentage('Beleuchtung', lightsValue),
    },
    {
      name: 'Office und Entertainment',
      color: '#258875',
      value: getPercentage(homeOfficeValue, total),
      kwh: Math.round(homeOfficeValue / 10) * 10,
      tipps: [
        {
          icon: 'gamepad',
          title: '8 Stunden',
          content: 'Playstation 4 spielen',
        },
        {
          icon: 'laptop',
          title: '33 Stunden',
          content: 'ein Notebook inklusive Internet nutzen',
        },
      ],
      average: getAveragePercentage(
        'Office und Entertainment',
        homeOfficeValue,
      ),
    },
  ];
  return {
    results,
  };
};

export { questions, getResults };
